import { getSupabase } from '../services/supabase';

export const AUDIT_EXPLORER_PAGE_SIZE = 50;

export const requestOperationsAuditInitialPage = async (signal: AbortSignal) => {
  const result = await getSupabase()
    .rpc('list_activity_events_redacted_v1', {
      target_limit: AUDIT_EXPLORER_PAGE_SIZE + 1,
    })
    .abortSignal(signal);
  if (result.error) throw result.error;
  return result.data;
};
